<template>
	<el-tabs v-model="activeTab" @tab-click="tabClicked" class="todo-block block">
		<el-tab-pane label="未读通告" name="public_notice">
			<el-table :show-header="false" :data="topUnreadPublicNotices" @row-click="onClickNotice" row-class-name="row">
				<el-table-column label="标题" prop="title" />
				<el-table-column label="日期" width="150">
					<template v-slot:default="slot">
						<p class="date">{{ slot.row.created_at | dateonly }}</p>
					</template>
				</el-table-column>
				<template v-slot:append v-if="topUnreadPublicNotices && topUnreadPublicNotices.length != 0"
					><router-link :to="{ name: 'publicNoticeList' }">
						<div class="todo-block-bottom">
							更多<svg class="icon" aria-hidden="true" style="margin-left: 4px;">
								<use xlink:href="#icon-iconfillenter"></use>
							</svg></div
					></router-link>
				</template>
			</el-table>
		</el-tab-pane>
		<el-tab-pane label="在途申报" name="onway_declaration">
			<el-table :show-header="false" :data="topOnWayDeclarations" @row-click="onClickDeclaration" row-class-name="row">
				<el-table-column label="流程" prop="declaration_process.name" />、
				<el-table-column label="学科" prop="subject.name" />
				<el-table-column label="状态" :width="14 * 6 + 70">
					<template v-slot:default="slot">{{ declaration_state_str(slot.row.state) }}</template>
				</el-table-column>
				<el-table-column label="处理人" prop="handler.realname" />

				<el-table-column label="发起时间" width="200" prop="created_at" />
				<template v-slot:append v-if="topOnWayDeclarations && topOnWayDeclarations.length != 0"
					><router-link
						:to="{
							name: 'declarationList',
							params: {
								sbid: $store.state.user.userInfo.student.class_grade.subjects[0].id
							}
						}"
					>
						<div class="todo-block-bottom">
							更多<svg class="icon" aria-hidden="true" style="margin-left: 4px;">
								<use xlink:href="#icon-iconfillenter"></use>
							</svg></div
					></router-link>
				</template>
			</el-table>
		</el-tab-pane>
		<el-tab-pane label="待完成评测" name="unfinished_test">
			<el-table :show-header="false" :data="topUnfinishedTests" @row-click="onClickTest" row-class-name="row">
				<el-table-column label="名称" prop="test.name" />

				<el-table-column label="学科" prop="test.subject.name" />

				<el-table-column align="left" label="类型" :width="14 * 6 + 70">
					<template v-slot:default="slot">{{ test_type_str(slot.row.test.type) }}</template>
				</el-table-column>

				<el-table-column align="left" label="状态" :width="14 * 6 + 70">
					<template v-slot:default="slot">{{ test_state_str(slot.row.state) }}</template>
				</el-table-column>

				<el-table-column label="创建日期" width="150">
					<template v-slot:default="slot">
						<p class="date">{{ slot.row.test.created_at | dateonly }}</p>
					</template>
				</el-table-column>
				<template v-slot:append v-if="topUnfinishedTests && topUnfinishedTests.length != 0"
					><router-link
						:to="{
							name: 'studentTest',
							params: {
								sbid: $store.state.user.userInfo.student.class_grade.subjects[0].id
							}
						}"
					>
						<div class="todo-block-bottom">
							更多<svg class="icon" aria-hidden="true" style="margin-left: 4px;">
								<use xlink:href="#icon-iconfillenter"></use>
							</svg></div
					></router-link>
				</template>
			</el-table>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
export default {
	data() {
		return {
			activeTab: 'public_notice',
			topUnreadPublicNotices: [],
			topUnfinishedTests: [],
			topOnWayDeclarations: []
		}
	},
	created() {
		this.refreshUnreadPublicNotice()
	},
	methods: {
		declaration_state_str(val) {
			switch (val) {
				case this.$api.declaration.state.DRAFTING.value:
					return '草拟中'
				case this.$api.declaration.state.IN_PROGRESS.value:
					return '待处理'
				case this.$api.declaration.state.PUBLIC_NOTICING.value:
					return '公示中'
				case this.$api.declaration.state.COMPLETED.value:
					return '已完成'
				case this.$api.declaration.state.REJECTED.value:
					return '已驳回'
			}
		},
		test_state_str(v) {
			return this.$api.answersheet.states.toText(v)
		},
		test_type_str(v) {
			return this.$api.test.types.toText(v)
		},
		async tabClicked(tabPanel) {
			switch (tabPanel.name) {
				case 'public_notice':
					// 请求未读
					this.refreshUnreadPublicNotice()
					break
				case 'unfinished_test':
					this.refreshUnfinishedTests()
					break
				case 'onway_declaration':
					this.refreshInProgressDeclarations()
					break
			}
		},
		onClickNotice(row) {
			this.$router.push({
				name: 'publicNoticeView',
				params: { id: row.id }
			})
		},
		onClickTest(row) {
			this.$router.push({
				name: 'studentTestDetail',
				params: { tid: row.test.id, asid: row.id, sbid: row.subject_id }
			})
		},
		onClickDeclaration(row) {
			this.$router.push({
				name: 'declarationView',
				params: { id: row.id, sbid: row.subject_id }
			})
		},
		async refreshUnreadPublicNotice() {
			// 请求个人未读公告
			let unreadNoticeRes = await this.$api.user.listInbox({
				filterBy: {
					state: 0
				},
				paginate: {
					size: 5
				}
			})

			this.topUnreadPublicNotices = unreadNoticeRes.data
		},
		async refreshInProgressDeclarations() {
			let res = await this.$api.user.listDeclaration(0, {
				filterBy: {
					state: [this.$api.declaration.state.IN_PROGRESS.value]
				},
				pov: 2,
				paginate: {
					size: 5
				}
			})
			this.topOnWayDeclarations = res.data
		},
		async refreshUnfinishedTests() {
			// 请求个人未读公告
			let res = await this.$api.answersheet.listStudentTests(0, {
				filterBy: {
					state: [this.$api.answersheet.states.NOT_STARTED.value, this.$api.answersheet.states.ON_GOING.value]
				},
				paginate: {
					size: 5
				}
			})
			this.topUnfinishedTests = res.data
		}
	}
}
</script>

<style></style>
